export default __webpack_public_path__ + "static/media/logo-no-bg.ff1630d9.svg";